import { SpecialAttackSkill, StatusSkill, PhysicalAttackSkill } from "../../core/skill";
import { Effect, RoundEffect } from "../../core/effect";
import { Timing } from "../../core/timing";

import * as type from "../../core/type";
import * as cond from "../../core/cond";
import * as effect from "../../core/effect";
import * as state from "../../core/state";

export const 圣堂之门 = new SpecialAttackSkill(
    "圣堂之门",
    type.圣灵,
    [
        "消除对手的能力提升，消除成功则使对手下1次释放的技能无效",
        "附加对手最大体力15%的固定伤害，每次使用增加10%，最多可叠加至45%，遇到天敌时固定伤害翻倍",
    ],
    100,
    [],
    3,
    false,
    1,
    5,
);

export const 璨灵圣光 = new StatusSkill(
    "璨灵圣光",
    [
        "100%令对手疲惫2回合，未触发则2回合内对手属性技能无效",
        "下2回合所有技能必定先出手、必定命中",
        "下2回合造成的伤害提升150%",
    ],
    [
        new Effect(new effect.施加异常状态(new state.疲惫(2)), Timing.onSkillHit),
        new RoundEffect(
            Timing.onSkillHit,
            2,
            new effect.增伤(150),
            Timing.beforeDamage,
            undefined,
            false,
            [],
        ).nextRound(),
    ],
);

export const 千烈虚光闪 = new SpecialAttackSkill(
    "千烈虚光闪",
    type.圣灵,
    ["消除双方的能力提升、能力下降、回合类效果", "清除双方所有技能的pp值"],
    150,
    [],
    0,
    false,
    1,
    5,
);

export const 旋灭裂空阵 = new PhysicalAttackSkill(
    "旋灭裂空阵",
    type.圣灵,
    ["全属性+1，体力高于1/2时强化效果翻倍", "3回合内，每回合都能附加300点固定伤害"],
    150,
    [
        new RoundEffect(
            Timing.onSkillHit,
            3,
            new effect.固伤(300),
            Timing.onDamage,
            undefined,
            false,
            [],
        ),
        new Effect(
            new effect.强化(1, cond.若自身体力高于x分之一(2)),
            Timing.onDamage,
        ),
    ],
    0,
    false,
    1,
    5,
);

export const 圣灵魔闪光 = new SpecialAttackSkill(
    "圣灵魔闪光",
    type.圣灵,
    [
        "消除对手的回合类效果，消除成功则3回合内对手无法通过自身技能恢复体力",
        "当回合未击败对手，则回合结束时自身特攻+1、速度+1，且下1次释放技能附加自身最大体力1/3的固定伤害",
        "吸取对手200点体力，每次使用增加100点，最高可叠加至400点，自身体力低于1/2时吸取效果翻倍",
    ],
    180,
    [
        new Effect(new effect.消除回合(), Timing.onDamage),
        new Effect(new effect.属性提升({ mAtk: 1, speed: 1 }), Timing.onDamage),
        new Effect(
            new effect.吸取体力(200, 100, 400, cond.若自身体力低于x分之一(2)),
            Timing.onDamage,
        ),
    ],
    0,
    true,
    1,
    5,
);
